<div [hidden]="!viewCondition" class="divider" [style.min-width]="minWidth" [style.min-height]="minHeight" [ngClass]="class">
  @for (child of children; track child) {
    <ng-template #children></ng-template>
  }
</div>
